var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopic1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.332 48.6667H31.9987C31.6305 48.6667 31.332 48.9652 31.332 49.3333C31.332 49.7015 31.6305 50 31.9987 50H33.332C33.7002 50 33.9987 49.7015 33.9987 49.3333C33.9987 48.9652 33.7002 48.6667 33.332 48.6667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9987 48.6667H35.9987C35.6305 48.6667 35.332 48.9652 35.332 49.3333C35.332 49.7015 35.6305 50 35.9987 50H51.9987C52.3669 50 52.6654 49.7015 52.6654 49.3333C52.6654 48.9652 52.3669 48.6667 51.9987 48.6667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.332 44.6667H31.9987C31.6305 44.6667 31.332 44.9652 31.332 45.3333C31.332 45.7015 31.6305 46 31.9987 46H33.332C33.7002 46 33.9987 45.7015 33.9987 45.3333C33.9987 44.9652 33.7002 44.6667 33.332 44.6667Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9987 44.6667H35.9987C35.6305 44.6667 35.332 44.9652 35.332 45.3333C35.332 45.7015 35.6305 46 35.9987 46H51.9987C52.3669 46 52.6654 45.7015 52.6654 45.3333C52.6654 44.9652 52.3669 44.6667 51.9987 44.6667Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.332 40.6667H31.9987C31.6305 40.6667 31.332 40.9652 31.332 41.3333C31.332 41.7015 31.6305 42 31.9987 42H33.332C33.7002 42 33.9987 41.7015 33.9987 41.3333C33.9987 40.9652 33.7002 40.6667 33.332 40.6667Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9987 40.6667H35.9987C35.6305 40.6667 35.332 40.9652 35.332 41.3333C35.332 41.7015 35.6305 42 35.9987 42H51.9987C52.3669 42 52.6654 41.7015 52.6654 41.3333C52.6654 40.9652 52.3669 40.6667 51.9987 40.6667Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.332 36.6667H31.9987C31.6305 36.6667 31.332 36.9652 31.332 37.3333C31.332 37.7015 31.6305 38 31.9987 38H33.332C33.7002 38 33.9987 37.7015 33.9987 37.3333C33.9987 36.9652 33.7002 36.6667 33.332 36.6667Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9987 36.6667H35.9987C35.6305 36.6667 35.332 36.9652 35.332 37.3333C35.332 37.7015 35.6305 38 35.9987 38H51.9987C52.3669 38 52.6654 37.7015 52.6654 37.3333C52.6654 36.9652 52.3669 36.6667 51.9987 36.6667Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.332 32.6667H31.9987C31.6305 32.6667 31.332 32.9652 31.332 33.3333C31.332 33.7015 31.6305 34 31.9987 34H33.332C33.7002 34 33.9987 33.7015 33.9987 33.3333C33.9987 32.9652 33.7002 32.6667 33.332 32.6667Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9987 32.6667H35.9987C35.6305 32.6667 35.332 32.9652 35.332 33.3333C35.332 33.7015 35.6305 34 35.9987 34H51.9987C52.3669 34 52.6654 33.7015 52.6654 33.3333C52.6654 32.9652 52.3669 32.6667 51.9987 32.6667Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6567 29.958C56.6534 29.8996 56.642 29.8419 56.6227 29.7867C56.6154 29.7653 56.61 29.7447 56.6007 29.724C56.5683 29.6515 56.5231 29.5853 56.4674 29.5287L47.134 20.1953C47.0774 20.1396 47.0112 20.0944 46.9387 20.062C46.918 20.0527 46.8974 20.0473 46.8767 20.04C46.821 20.0208 46.7629 20.0092 46.704 20.0053C46.6927 20.0073 46.68 20 46.6654 20H27.9987C27.6305 20 27.332 20.2985 27.332 20.6667V22.6667H23.9987C23.6305 22.6667 23.332 22.9652 23.332 23.3333V59.3333C23.332 59.7015 23.6305 60 23.9987 60H51.9987C52.3669 60 52.6654 59.7015 52.6654 59.3333V56H55.9987C56.3669 56 56.6654 55.7015 56.6654 55.3333V30C56.6654 29.9853 56.658 29.9727 56.6567 29.958ZM47.332 22.276L54.3894 29.3333H47.332V22.276ZM51.332 58.6667H24.6654V24H27.332V55.3333C27.332 55.7015 27.6305 56 27.9987 56H51.332V58.6667ZM55.332 54.6667H28.6654V21.3333H45.9987V30C45.9987 30.3682 46.2972 30.6667 46.6654 30.6667H55.332V54.6667Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9987 26H31.9987C31.6305 26 31.332 26.2985 31.332 26.6667V30.6667C31.332 31.0348 31.6305 31.3333 31.9987 31.3333H35.9987C36.3669 31.3333 36.6654 31.0348 36.6654 30.6667V26.6667C36.6654 26.2985 36.3669 26 35.9987 26ZM35.332 30H32.6654V27.3333H35.332V30Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FB0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A7AFB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic1);
export default __webpack_public_path__ + "static/media/topic-1.81f4cd97cb56b80170dd4b7e37f0fa17.svg";
export { ForwardRef as ReactComponent };